import AssignmentMark from "../../../components/Admin/AssignmentMark";
import Navbar from "../../../components/Navbar";

export default function AssignmentMarkPage() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <AssignmentMark />
        </div>
      </section>
    </>
  );
}
